var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3363_4195",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3363_4195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 23.5122C21.2 23.5122 18.8333 22.5691 16.9 20.6829C14.9667 18.7967 14 16.4878 14 13.7561C14 11.0894 14.9667 8.79675 16.9 6.87805C18.8333 4.95935 21.2 4 24 4C26.8 4 29.1667 4.95935 31.1 6.87805C33.0333 8.79675 34 11.0894 34 13.7561C34 16.4878 33.0333 18.7967 31.1 20.6829C29.1667 22.5691 26.8 23.5122 24 23.5122ZM4.8 44C3.93333 44 3.25 43.7398 2.75 43.2195C2.25 42.6992 2 42.0488 2 41.2683V38.5366C2 37.3008 2.31667 36.2276 2.95 35.3171C3.58333 34.4065 4.6 33.561 6 32.7805C8.8 31.2846 11.7167 30.1789 14.75 29.4634C17.7833 28.748 20.8667 28.3902 24 28.3902C27.1333 28.3902 30.2167 28.748 33.25 29.4634C36.2833 30.1789 39.2 31.2846 42 32.7805C43.3333 33.561 44.3333 34.4065 45 35.3171C45.6667 36.2276 46 37.3008 46 38.5366V41.2683C46 42.0488 45.75 42.6992 45.25 43.2195C44.75 43.7398 44.0667 44 43.2 44H4.8Z",
    fill: "#7B7B7B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.5ed4295381557124195689d88b58484d.svg";
export { ForwardRef as ReactComponent };